import api from './api';

/**
 * Create a vehicle booking.
 * @param {Object} payload
 * @param {string} payload.vehicle_type_id
 * @param {string} payload.pickup_location_id
 * @param {string} payload.drop_location_id
 * @param {string} payload.trip_type   // 'one_way' | 'round_trip' | 'rental'
 * @param {string} payload.pickup_date // ISO UTC date-time
 * @param {string} payload.drop_date   // ISO UTC date-time
 * @param {string} payload.pickup_time // HH:mm
 * @param {string} payload.drop_time   // HH:mm
 * @param {string} payload.ride_mode   // 'one_way' | 'round_trip' | 'rental'
 */
export const createBooking = async (payload) => {
  const { data } = await api.post('/vehicle/vehicle-booking', payload);
  return data;
};

// Fetch bookings for the signed-in customer.
export const getMyBookings = async () => {
  const { data } = await api.get('/vehicle/vehicle-booking/customer/my-bookings');
  return data;
};

export const getBookingDetails = async (bookingId) => {
  const { data } = await api.get(`/vehicle/vehicle-booking/${bookingId}`);
  return data;
};

export const createCabComplaint = async (payload) => {
  const { data } = await api.post('/vehicle/cab-complaints/customer', payload);
  return data;
};

export const createCabDispute = async (payload) => {
  const { data } = await api.post('/vehicle/cab-disputes/customer', payload);
  return data;
};